import React from 'react';
import { useState } from 'react';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from 'react-router-dom';

export default function HeadGeneralAdd() {
    const navigate = useNavigate();
    const { http, user } = AuthUser();
    const [formData, setFormData] = useState({
        name: '',
        alpha: '',
    });

    const initialState = {
        name: '',
        alpha: '',
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const dataToSubmit = {
            ...formData,
            company_id: String(user.company_id)
        };

        try {
            http.post('/head_general', dataToSubmit).then((res) => {
                toast.success("Head Receipt added successfully!");
                setFormData(initialState);
                navigate('/head_general_list');
            });
        } catch (error) {
            console.error('Error adding Head Receipt:', error.response?.data);
            toast.error("Error adding Head Receipt");
        }
    };

    return (
        <>
            <div className="container mt-5">
                <Toaster />
                <h3>Add Head Receipt</h3>
                <form onSubmit={handleSubmit}>
                    <div className='form-group mt-3'>
                        <label>Name</label>
                        <input
                            name="name"
                            className='form-control'
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className='form-group mt-3'>
                        <label>Alpha</label>
                        <input
                            name="alpha"
                            className='form-control'
                            value={formData.alpha}
                            onChange={handleChange}
                        />
                    </div>
                    <button className='btn button btn-success mt-3' type="submit">Add</button>
                </form>
            </div>
        </>
    );
}

